/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.1-v202611050049-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export interface CustomAgentTriggerInputV1 {
    /**
     * The saved trigger kind
     */
    "kind": KindEnum;
    "schedule"?: models.CustomAgentScheduleTriggerInputV1;
}

export const KindEnum = {
    Schedule: 'schedule'
} as const;

export type KindEnum = typeof KindEnum[keyof typeof KindEnum];
